import * as React from "react";
import StoreMap from "./store-map";
import StoreList from "./store-list";
export default class StoreResults extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { stores, selected, updateSelected, mapOptions, clusters, searchText, amenitesFilter } = this.props;
        return (React.createElement("div", { className: "store-results" },
            React.createElement(StoreList, { getLocation: this.props.getLocation, stores: stores, selected: selected, searchText: searchText, updateSearchText: this.props.updateSearchText, amenitesFilter: amenitesFilter, updateFilter: this.props.updateFilter, updateSelected: updateSelected, MarkerClick: this.props.MarkerClick, clearFilter: this.props.clearFilter, updateAddressText: this.props.updateAddressText }),
            React.createElement(StoreMap, { mapOptions: mapOptions, stores: stores, clusters: clusters, selected: selected, updateSelected: updateSelected, handleMapChange: this.props.handleMapChange, clusterMarkerClick: this.props.clusterMarkerClick })));
    }
}
;
//# sourceMappingURL=store-results.js.map